<template>
  <div class="wrapper">
    <!-- 征文入口 -->
    <div class="zw-entry">
      <div class="zw-wrap">
        <div class="zw-img"></div>
        <div class="zw-desc">
          参加南方周末【笔尖上的少年】征文活动 名家点评、 赴京游学、集结出书
        </div>
        <div class="zw-btn" @click="gotoSummerCamp">参加征文</div>
      </div>
    </div>
    <!-- 跟着老师学写作 -->
    <!-- <div class="zw-entry xz-entry">
      <div class="zw-wrap">
        <div class="zw-img"></div>
        <div class="zw-desc">
          参与跟着老师学写作活动，学习更多写作小技巧， 练笔赢取金币吧
        </div>
        <div class="zw-btn" @click="gotoWriting">去练笔</div>
      </div>
    </div> -->

  </div>
</template>
<script>
import { mapState } from 'vuex'
import { COMPATION, XIECHENG, SOURCEID, WRITEPAGE, XCRIGHTLIST } from '../const'
import { isApp, getUrlParmas } from '@/common/utils/xesFunction.js'
export default {
  data() {
    return {
      xcrightsList: XCRIGHTLIST,
      isApp: isApp()
    }
  },
  // props: {
  //   isLogin: {
  //     type: Boolean
  //   },
  //   isAward: {
  //     type: Boolean
  //   }
  // },
  // watch: {
  //   isLogin(val) {
  //     if (val) {
  //       this.isLogin = val
  //     }
  //   },
  //   isAward(val) {
  //     if (val) {
  //       this.isAward = val
  //     }
  //   }
  // },
  computed: {
    ...mapState(['phoneNum'])
  },
  methods: {
    // 兑换携程权益
    async handleCharge() {
      this.$xesLogger.clickMsg({
        params: {
          clickid: 12,
          action: 'click',
          elemname: '点击领取携程权益'
        }
      })

      const url = `${XIECHENG}&legaophone=${this.phoneNum || ''}`
      const _url =
        'https://contents.ctrip.com/activitysetupapp/mkt/index/tal123?allianceid=3192568&sid=6497424'
      setTimeout(() => {
        window.location.href = this.isApp ? _url : url
      }, 300)
    },
    // 征文
    gotoSummerCamp() {
      this.$xesLogger.clickMsg({
        params: {
          clickid: 13,
          action: 'click',
          elemname: '点击征文入口'
        }
      })

      setTimeout(() => {
        const { channelId = '' } = this.$route.query || {}
        const { inviterId = '' } = getUrlParmas(location.href)
        window.location.href = `${COMPATION}?to_summercamp=1&inviterId=${inviterId}&sourceId=${SOURCEID}&channelId=${channelId}`
      }, 300)
    },
    gotoWriting() {
      this.$xesLogger.clickMsg({
        params: {
          clickid: 34,
          elemname: '点击跟老师学写作'
        }
      })
      setTimeout(() => {
        window.location.href = `${WRITEPAGE}?sourceId=${SOURCEID}`
      }, 300)
    }
  }
}
</script>
<style lang="less">
.wrapper {
  padding-bottom: 10px;
}

.zw-entry {
  position: relative;
  height: 582px/2;
  margin: 8px auto 0;
  margin-top: 0;
  overflow: hidden;
  font-weight: bold;
  background: url('../assets/images/zw-bg.png') no-repeat;
  background-size: cover;

  .zw-wrap {
    padding: 136px/2 90px/2 0 85px/2;
    font-size: 12px;
    color: #a6662e;

    .zw-desc {
      margin-top: 13px;
    }

    .zw-img {
      width: 100%;
      height: 154px/2;
      margin: 0 auto;
      background: url(../assets/images/zw-banner.png) no-repeat;
      background-size: cover;
      border-radius: 10px;
    }

    .zw-btn {
      width: 342px/2;
      height: 88px/2;
      margin: 13px auto;
      font-size: 17px;
      font-weight: bold;
      line-height: 80px/2;
      text-align: center;
      color: #fff;
      background: url(../assets/images/btn-desc.png) no-repeat;
      background-size: 100% auto;
    }
  }
}

.xz-entry {
  margin-top: 0;
  background-image: url('../assets/images/write-bg.png') !important;

  .zw-img {
    background-image: url(../assets/images/write-banner.png) !important;
  }
}

.xc-entry {
  position: relative;
  height: 622px/2;
  margin: 8px auto 0;
  overflow: hidden;
  background: url('../assets/images/ribg.png') no-repeat;
  background-size: cover;

  .xc-wrap {
    display: flex;
    margin: 0 auto;
    margin: 132px/2 42px 0 40px;

    .xclist {
      flex: 1;
      text-align: center;

      .xcimg {
        width: 150px/2;
        height: 150px/2;
        margin: 0 auto;
        background: #ccc;
      }

      .img0 {
        background: url(../assets/images/ri0.png) no-repeat;
        background-size: cover;
      }

      .img1 {
        background: url(../assets/images/ri1.png) no-repeat;
        background-size: cover;
      }

      .img2 {
        background: url(../assets/images/ri2.png) no-repeat;
        background-size: cover;
      }

      .title {
        // padding: 0 10px;
        margin-top: 27px/2;
        font-size: 13px;
        font-weight: bold;
        font-family: FZPinShangHeiS-DB-GB;
        color: #a6662e;
      }

      .desc {
        font-size: 13px;
        font-weight: bold;
        font-family: FZPinShangHeiS-DB-GB;
        color: #a6662e;
      }
    }
  }

  .xc-btn {
    width: 342px/2;
    height: 88px/2;
    margin: 13px auto 8px;
    font-size: 17px;
    font-weight: bold;
    line-height: 80px/2;
    text-align: center;
    color: #fff;
    background: url(../assets/images/btn-desc.png) no-repeat;
    background-size: 100% auto;
  }

  .xc-rule {
    font-size: 11px;
    text-align: center;
    color: #acacac;
  }
}

.com-product {
  position: relative;
  width: 100%;
  margin-top: 12px;
  // 图片高/图片宽
  // padding-bottom: 239/750*100%;

  &-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
